export default {"src":"/_next/static/media/arrow_black.5916163c.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};